// src/services/requestsServices.js

import axios from "axios";

const API_BASE ="https://api.monappliclub.com";

const baseUrl = `${API_BASE}/api/requests`;

export const getRequestsByAssociationId = async (associationId) => {
  const { data } = await axios.get(
    `${baseUrl}/RequestsByAssociationId/${associationId}`
  );
  return data;
};

export const createRequest = async (payload) => {
  const { data } = await axios.post(`${baseUrl}/addRequest`, payload);
  return data;
};

export const updateRequest = async (id, payload) => {
  const { data } = await axios.patch(`${baseUrl}/updateRequest/${id}`, payload);
  return data;
};

export const deleteRequest = async (id) => {
  const { data } = await axios.delete(`${baseUrl}/deleteRequest/${id}`);
  return data;
};